"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
exports.AcTableSelectorHeaderCell = function (props) {
    var _a = react_1.useState(true), checked = _a[0], setChecked = _a[1];
    var onClick = function () {
        if (props.onSelectAll) {
            props.onSelectAll(checked);
        }
        setChecked(!checked);
    };
    return (React.createElement("th", { className: "border-top-0", style: { width: '40px' } },
        React.createElement("div", { className: "custom-control custom-checkbox", onClick: onClick },
            React.createElement("input", { type: "checkbox", className: "custom-control-input", checked: !checked }),
            React.createElement("label", { className: "custom-control-label" }))));
};
exports.AcTableSelectorHeaderCell.displayName = 'AcTableSelectorHeaderCell';
//# sourceMappingURL=AcTableSelectorHeaderCell.js.map